import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import { IoRocket, IoTelescope } from 'react-icons/io5';
import { FiGrid, FiLogOut, FiShield } from 'react-icons/fi';

const Navbar = () => {
  const { user, logout } = useApp();
  const location = useLocation();

  const NavItem = ({ to, icon: Icon, label }) => (
    <Link
      to={to}
      className={`flex items-center space-x-2 px-4 py-2 rounded-full transition-all duration-300 ${
        location.pathname === to
          ? 'bg-blue-600 text-white shadow-[0_0_15px_rgba(37,99,235,0.5)]'
          : 'text-slate-400 hover:text-white hover:bg-slate-800'
      }`}
    >
      <Icon size={18} />
      <span>{label}</span>
    </Link>
  );

  return (
    <nav className="fixed top-0 left-0 w-full z-50 border-b border-slate-800 bg-slate-950/80 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="p-2 bg-gradient-to-tr from-blue-600 to-purple-600 rounded-lg group-hover:shadow-[0_0_20px_rgba(147,51,234,0.5)] transition-all duration-500">
              <IoRocket className="text-white" size={24} />
            </div>
            <div className="flex flex-col leading-none">
              <span className="font-black text-lg tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
                THE CAPSULE
              </span>
              <span className="text-[10px] font-bold text-slate-500 uppercase tracking-[0.2em]">
                by Maysalward
              </span>
            </div>
          </Link>

          <div className="hidden md:flex items-center space-x-2">
            <NavItem to="/galaxy" icon={IoTelescope} label="Universe" />
            {user ? (
              <>
                {user.type === 'admin' ? (
                  <NavItem to="/admin" icon={FiShield} label="Mission Control" />
                ) : (
                  <NavItem to="/dashboard" icon={FiGrid} label="My Capsule" />
                )}
                <button
                  onClick={logout}
                  className="flex items-center space-x-2 px-4 py-2 text-slate-400 hover:text-red-400 transition-colors ml-4"
                >
                  <FiLogOut size={18} />
                  <span>Logout</span>
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className="ml-4 px-6 py-2 bg-white text-slate-900 rounded-full font-bold hover:bg-blue-50 transition-colors text-sm"
              >
                Join Capsule
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;